import React, { useEffect } from "react";
import { useState } from "react";
import { MyContext } from "../DashClienteMainScreen";
import { useContext } from "react";
import {
  TextField,
  MenuItem,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ArticleIcon from "@mui/icons-material/Article";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import Swal from "sweetalert2";
import { GetKey } from "../../../../Helpers/GetKey";
import request from "../../../../Helpers/API";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { ValFormReg, ValForm } from "../../../../Validators/ValForms";
import { RegularExpressions } from "../../../../Helpers/RegularExpression";
import { AsistenteSolicitud } from "./AsistenteSolicitudCredito";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Agriculture from "@mui/icons-material/Agriculture";
import SendIcon from "@mui/icons-material/Send";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { Moneda } from "../../../../Helpers/Moneda";
import { ValOnlyNumber } from "../../../../Validators/ValOnlyNumber";



export const DashGenerarSolicitudCredito = () => {
  const location = useLocation();
  // Se usa tanto dentro de DashClienteMainScreen (idcliente/folio vía MyContext) como
  // dentro de CRMMainScreen (sin ese Provider); location.state (enviado por
  // SolicitudCreditoListadoScreen) tiene prioridad y el contexto queda como respaldo.
  const context = useContext(MyContext);
  const [state, setState] = useState({
    idcliente: location.state?.idcliente ?? context?.state?.idcliente,
    cliente: location.state?.cliente ?? context?.state?.cliente,
    folio: location.state?.folio ?? context?.state?.folio ?? 0,
    tipo_solicitud: location.state?.tipo_solicitud ?? context?.state?.tipo_solicitud ?? "",
  });
  const [capp, setCapp] = useState(false);
  const [vendedores, setVendedores] = useState([]);
  const history = useHistory();
  const [solicitud, setSolicitud] = useState({
    tiposolicitud: "",
    importe: 0,
    autoriza_credito: "",
    estatus: "",
    nivel_riesgo: "",
    asesor: "",
    asesor_asignado: "",
    config: {},
  });
  const [creadorsolicitud, setCreadorsolicitud] = useState(false)


  useEffect(() => {
    if (capp) {
      // setLoading(true);
      request
        .get("DDLVendedor/Listado")
        .then((result) => {
          // setLoading(false);
          setVendedores(result);
        })
        .catch((error) => {
          // setLoading(false);
          Swal.fire("CLIENTES", JSON.stringify(error), "error");
        });
    }
  }, [capp]);

  const onGuardar = () => {
    const tiposolicitudValidation = ValForm(
      "Tipo de Solicitud",
      solicitud.tiposolicitud
    );
    const importeValidation = ValFormReg(
      "Monto Solicitado",
      solicitud.importe,
      RegularExpressions.TextOnlyNumber
    );
    if (!tiposolicitudValidation.isValid || !importeValidation.isValid) {
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        html: `
            ${tiposolicitudValidation.mensaje}
            ${importeValidation.mensaje}
          `,
      });
      return;
    }

    const post = {
      folio: state.folio === 0 || state.folio === "" ? -999 : state.folio,
      idcliente: state.idcliente,
      tipo_solicitud: GetKey(solicitud.tiposolicitud),
      importe: Number(solicitud.importe),
      usuario: solicitud.asesor,
      vendedor: solicitud.asesor_asignado,
    };

    if (post.usuario === "sin asignar") {
      Swal.fire({
        title: "SOLICITUD DE CREDITO",
        text: "Seleccione un asesor",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    } else {
      request
        .post("SolicitudCredito", post)
        .then(async (result) => {
          const smensaje =
            state.folio === 0 || state.folio === "Solicitud creada con éxito"
              ? -999
              : "Solicitud modificada con exito";
          setState({
            ...state,
            folio: result.solicitud_credito.folio,
            tipo_solicitud: GetKey(solicitud.tiposolicitud),
          });
          setSolicitud({
            tiposolicitud: result.solicitud_credito.tipo_solicitud,
            importe: result.solicitud_credito.importe,
            autoriza_credito: result.solicitud_credito.autoriza_credito,
            estatus: result.solicitud_credito.estatus,
            nivel_riesgo: result.solicitud_credito.nivel_riesgo,
            config: result.config,
          });
          await Swal.fire("SOLICITUD DE CREDITO", smensaje, "success");
          // AsistenteSolicitud(
          //   result.config.pantalla,
          //   result.config.vista,
          //   history,
          //   result.solicitud_credito.tipo_solicitud,
          //   result.solicitud_credito.folio,
          //   state.cliente
          // );
        })
        .catch((error) => {
          Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
        });
    }
  };
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const onEnviar = () => {
    if (state.folio.length !== 13 || solicitud.config.pantalla !== "TER") {
      return;
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(`SolicitudCredito/enviar?folio=${state.folio}`)
      .then(() => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "SOLICITUD DE CREDITO",
          "Solicitud enviada a revision",
          "success"
        );
        history.push("/DashClientes/solicitudcreditolistado");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUD DE CREDITDO", JSON.stringify(error), "error");
      });
  };
  // Folio ausente/vacío/0 = solicitud nueva; se consulta con un folio placeholder para traer solo la config inicial
  const hayFolioExistente = state.folio !== undefined && state.folio !== null && state.folio !== "" && state.folio !== 0;
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SolicitudCredito/detalle?folio=${hayFolioExistente ? state.folio : '000000000000'}`)
      .then((result) => {
        if (hayFolioExistente && result?.solicitud_credito) {
          setSolicitud({
            tiposolicitud: result.solicitud_credito.tipo_solicitud,
            importe: result.solicitud_credito.importe,
            autoriza_credito: result.solicitud_credito.autoriza_credito,
            estatus: result.solicitud_credito.estatus,
            nivel_riesgo: result.solicitud_credito.nivel_riesgo,
            config: result.config,
            asesor: result.asesor?.asesor,
            asesor_asignado: result.asesor?.asesor,
          });
          setCreadorsolicitud(result.asesor?.creadorsolicitud)
          document.getElementById("importe-sc").value = FormatMoney(
            result.solicitud_credito.importe
          );
        }
        if (result.capp !== null) {
          setCapp(true);
        }
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUD CREDITO", JSON.stringify(error), "error");
      });
    // }
  }, []);
  const onFocus = (e) => {
    e.target.type = "number";
  };
  const onBlur = (e, prop) => {
    e.target.type = "text";
    e.target.value = FormatMoney(Number(solicitud[prop]));
  };

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setSolicitud({
      ...solicitud,
      [prop]: sinComas
    });
  };


  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  };

  const onActivarSolicitud = (accion) => {
    setLoader({ ...loader, mostrar: true });

    const comentarios = "Solicitud activada por vendedor"

    const post = {
      folio: state.folio,
      accion: accion,
      comentarios: comentarios,
    };
    request
      .post(`PanelControlSolicitudes`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        history.push("/DashClientes/solicitudcreditolistado");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }

  return (
    <div className="crm-main-screen">
      <div className="crm-body">
        <div className="crm-page">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button
                    className="crm-btn-regresar"
                    onClick={() => {
                      history.push("/DashClientes/Solicitud_Credito", { idcliente: state.idcliente, cliente: state.cliente });
                    }}
                  >
                    <ArrowBackIcon /> Regresar
                  </button>
                </div>
                <div className="crm-head-center">
                  <h1 className="crm-module-title">CREAR SOLICITUD DE CRÉDITO</h1>
                </div>
                <div className="crm-head-right" />
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>
            <div className="Dash-generar-solicitud-credito">
              <LoaderScreen loader={loader} />
              <div className="Dash-generar-solicitud-credito-container">
                <div className="Dash-generar-solicitud-credito-container-buttons">
                  <button
                    className={`Dash-generar-solicitud-credito-container-buttons-btn ${Number(state.folio) === 0 ||
                      (solicitud.tiposolicitud !== "O" &&
                        solicitud.tiposolicitud !== "J" &&
                        solicitud.tiposolicitud !== "C")
                      ? "Dash-generar-solicitud-credito-container-buttons-disabled"
                      : ""
                      }`}
                    onClick={() => {
                      if (
                        Number(state.folio) !== 0 &&
                        (solicitud.tiposolicitud === "O" ||
                          solicitud.tiposolicitud === "J" ||
                          solicitud.tiposolicitud === "C")
                      )
                        history.push(
                          "/DashClientes/solicitudcredito/pedidos",
                          {
                            vista:
                              (solicitud.tiposolicitud === "O" ||
                                solicitud.tiposolicitud === "J" ||
                                solicitud.tiposolicitud === "C") &&
                                (solicitud.config.pantalla === "NOI" ||
                                  solicitud.config.pantalla === "PED")
                                ? solicitud.config.vista
                                : 3,
                            // Se envían para que DashPedidoMaquinariascreen no dependa de MyContext
                            folio: state.folio,
                            idcliente: state.idcliente,
                            tipo_solicitud: state.tipo_solicitud,
                          }
                        );
                    }}
                  >
                    <ArticleIcon />
                    Capturar Pedido
                  </button>
                  <button
                    className={`Dash-generar-solicitud-credito-container-buttons-btn 
                      ${Number(state.folio) === 0 ||
                      (solicitud.config.pantalla !== "SCR" &&
                        solicitud.config.pantalla !== "DOC" &&
                        solicitud.config.pantalla !== "TER")
                      ? "Dash-generar-solicitud-credito-container-buttons-disabled"
                      : ""
                      }`
                    }
                    onClick={() => {
                      if (
                        Number(state.folio !== 0) &&
                        (solicitud.config.pantalla === "SCR" ||
                          solicitud.config.pantalla === "DOC" ||
                          solicitud.config.pantalla === "TER")
                      )
                        history.push(
                          "/DashClientes/solicitudcredito/crear",
                          {
                            vista: solicitud.config.vista,
                            // Se envían para que DashCrearSolicitudCredito no dependa de MyContext
                            folio: state.folio,
                            idcliente: state.idcliente,
                            tipo_solicitud: state.tipo_solicitud,
                          }
                        );
                    }}
                  >
                    <ChecklistIcon />
                    Capturar Solicitud
                  </button>
                  {creadorsolicitud === true && (
                    <button
                      className={`Dash-generar-solicitud-credito-container-buttons-btn ${Number(state.folio) === 0 ||
                        (solicitud.config.pantalla !== "SCR" &&
                          solicitud.config.pantalla !== "DOC" &&
                          solicitud.config.pantalla !== "TER")
                        ? "Dash-generar-solicitud-credito-container-buttons-disabled"
                        : ""
                        }`}
                      onClick={() => onActivarSolicitud("A")}
                    >
                      <SendIcon />
                      Activar Solicitud
                    </button>
                  )}

                  {/* <button
            className={`Dash-generar-solicitud-credito-container-buttons-btn ${
              Number(state.folio) === 0 ||
              (solicitud.config.pantalla !== "TER" &&
                solicitud.config.pantalla !== "DOC")
                ? "Dash-generar-solicitud-credito-container-buttons-disabled"
                : ""
            }`}
            onClick={() => {
              if (
                Number(state.folio !== 0) &&
                (solicitud.config.pantalla === "TER" ||
                  solicitud.config.pantalla === "DOC")
              )
                history.push(
                  "/DashClientes/solicitudcredito/documentacion",
                  { pantalla: solicitud.config.pantalla }
                );
            }}
          >
            <FolderSharedIcon />
            DOCUMENTACION
          </button> */}
                  {state.tipo_solicitud === "A" ? (
                    <button
                      onClick={() => onEnviar()}
                      className={`Dash-generar-solicitud-credito-container-buttons-btn ${Number(state.folio) === 0 || solicitud.config.pantalla !== "TER"
                        ? "Dash-generar-solicitud-credito-container-buttons-disabled"
                        : ""
                        }`}
                    >
                      <SendIcon />
                      ENVIAR
                    </button>) : (<div></div>)}
                </div>
                <div className="Dash-generar-solicitud-credito-titulo">
                  Solicitud de Crédito
                </div>

                <div className="Dash-generar-solicitud-credito-controls">
                  {state.folio !== undefined &&
                    state.folio !== null &&
                    state.folio.length === 13 ? (
                    <div className="Dash-generar-solicitud-credito-detalle">
                      <div className="Dash-generar-solicitud-credito-detalle">
                        <div className="Dash-generar-solicitud-credito-detalle-item">
                          <div className="Dash-generar-solicitud-credito-detalle-item-label">
                            Folio
                          </div>
                          <div className="Dash-generar-solicitud-credito-detalle-item-value">
                            {state.folio === 0 ? "NUEVA SOLICITUD" : state.folio}
                          </div>
                        </div>
                      </div>
                      <div className="Dash-generar-solicitud-credito-detalle-item">
                        <div className="Dash-generar-solicitud-credito-detalle-item-label">
                          Nivel de Riesgo
                        </div>
                        <div className="Dash-generar-solicitud-credito-detalle-item-value">
                          {solicitud.nivel_riesgo}
                        </div>
                      </div>
                      <div className="Dash-generar-solicitud-credito-detalle-item">
                        <div className="Dash-generar-solicitud-credito-detalle-item-label">
                          Autoriza Crédito
                        </div>
                        <div className="Dash-generar-solicitud-credito-detalle-item-value">
                          {capitalizeWords(solicitud.autoriza_credito)}
                        </div>
                      </div>
                      <div className="Dash-generar-solicitud-credito-detalle-item">
                        <div className="Dash-generar-solicitud-credito-detalle-item-label">
                          Estatus
                        </div>
                        <div className="Dash-generar-solicitud-credito-detalle-item-value">
                          {capitalizeWords(solicitud.estatus)}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <TextField
                    fullWidth
                    size="small"
                    label="Linea de Crédito Solicitada"
                    variant="outlined"
                    className="cel-1"
                    select
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Agriculture fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                    type="text"
                    onChange={({ target }) => {
                      setSolicitud({
                        ...solicitud,
                        tiposolicitud: target.value,
                      });
                    }}
                    value={solicitud.tiposolicitud}
                    sx={{
                      mt: 2,
                    }}
                    disabled={
                      state.folio === undefined ||
                        state.folio === null ||
                        state.folio.length !== 13
                        ? false
                        : true
                    }
                  >
                    <MenuItem value={"O"}>CREDITO DE OPERACION</MenuItem>
                    <MenuItem value={"C"}>VENTA DE CONTADO</MenuItem>
                    <MenuItem value={"A"}>
                      AMPLIACION LINEA DE CREDITO REVOLVENTE
                    </MenuItem>
                    <MenuItem value={"E"}>
                      EXCEDENTE LINEA DE CREDITO REVOLVENTE
                    </MenuItem>
                    <MenuItem value={"J"}>JOHN DEERE FINANCIAL</MenuItem>
                  </TextField>

                  <TextField
                    fullWidth
                    label="Valor de la Operación"
                    size="small"
                    color="success"
                    className="tc-white"
                    type="text"
                    id="importe-sc"
                    name="importe"
                    // onChange={({ target }) =>
                    // setSolicitud({
                    //   ...solicitud,
                    //     importe: target.value.toUpperCase(),
                    //   })
                    // }
                    onChange={({ target }) => {
                      ValOnlyNumber("importe", target.value, onChange, true, 15);
                    }}
                    onKeyUp={(input) => Moneda(input.target)}
                    // onFocus={onFocus}
                    // onBlur={(e) => onBlur(e, "importe")}
                    inputProps={{
                      maxLength: 50,
                    }}
                    sx={{ mt: 2 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon size="small" />
                        </InputAdornment>
                      ),
                    }}
                    disabled={
                      state.folio === undefined ||
                        state.folio === null ||
                        state.folio.length !== 13
                        ? false
                        : true
                    }
                  />
                  {capp === true ? (
                    <TextField
                      fullWidth
                      size="small"
                      label="Vendedor Asignado"
                      variant="outlined"
                      className="cel-1"
                      select
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AssignmentIndIcon fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                      type="text"
                      onChange={({ target }) => {
                        setSolicitud({
                          ...solicitud,
                          asesor: target.value,
                        });
                      }}
                      value={solicitud.asesor}
                      sx={{
                        mt: 2,
                      }}
                    >
                      {vendedores.map((item) => (
                        <MenuItem key={item.idvendedor} value={item.idvendedor}>
                          {item.vendedor}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="Dash-generar-solicitud-credito-container-buttons-footer">
                  <button
                    onClick={() => onGuardar()}
                    className="Dash-generar-solicitud-credito-container-buttons-btn"
                  >
                    <SaveIcon />
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};